export default __webpack_public_path__ + "static/media/home.bdb046a9.svg";